<template>
  <div class="ui-tabs" role="tablist" :data-tone="tone ?? undefined">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      class="ui-tabs__tab"
      :class="{ 'is-active': modelValue === tab.value }"
      type="button"
      role="tab"
      :aria-selected="modelValue === tab.value"
      @click="emit('update:modelValue', tab.value)"
    >
      <span v-if="tab.icon" class="ui-tabs__icon">{{ tab.icon }}</span>
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string;
  tabs: { value: string; label: string; icon?: string }[];
  tone?: "travel" | "work" | "combat" | "econ" | "social" | null;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();
</script>

<style scoped>
.ui-tabs {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  row-gap: 0.35rem;
  padding: 0.35rem;
  border-radius: var(--radius-pill);
  background: var(--tabs-bg);
  border: 1px solid var(--tabs-border);
}

.ui-tabs__tab {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.85rem;
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  color: var(--fg-1);
  font-size: 0.85rem;
}

.ui-tabs__tab.is-active {
  color: var(--fg-0);
  background: color-mix(in srgb, var(--accent) 18%, transparent);
  border-color: color-mix(in srgb, var(--accent) 42%, transparent);
}

.ui-tabs__icon {
  font-size: 0.9rem;
}

.ui-tabs[data-tone="travel"] {
  --accent: var(--accent-travel);
}

.ui-tabs[data-tone="work"] {
  --accent: var(--accent-work);
}

.ui-tabs[data-tone="combat"] {
  --accent: var(--accent-combat);
}

.ui-tabs[data-tone="econ"] {
  --accent: var(--accent-econ);
}

.ui-tabs[data-tone="social"] {
  --accent: var(--accent-social);
}
</style>
